import { useState } from 'react';
import { KPODataFetchWrapper } from '../wrappers/KPODataFetchWrapper';
import { DataFetchFunction } from '../types/ProgressTypes';
import { EupType } from "../../model";

export const useKpoData = (onComplete?: () => void) => {
    const [showProgress, setShowProgress] = useState(false);
    const [fetchDataFunction, setFetchDataFunction] = useState<DataFetchFunction | null>(null);

    const fetchKpoData = (
        eupType: EupType,
        dateFrom: Date,
        dateTo: Date,
        sheetName: string
    ) => {
        // Zapisz aktualną ścieżkę dla powrotu
        sessionStorage.setItem('kpoReturnPath', location.pathname);

        const dataFetch = KPODataFetchWrapper.wrapKpoConfirmedDataFetch(
            eupType,
            dateFrom,
            dateTo,
            sheetName,
        );
        setFetchDataFunction(() => dataFetch);
        setShowProgress(true);
    };

    const resetProgress = () => {
        setShowProgress(false);
        setFetchDataFunction(null);
    };

    const handleProgressComplete = (wasSuccess: boolean) => {
        resetProgress();
        // Wywołaj callback przekazany z komponentu rodzica tylko przy sukcesie
        if (wasSuccess && onComplete) {
            onComplete();
        }
    };

    return {
        showProgress,
        fetchDataFunction,
        fetchKpoData,
        resetProgress,
        handleProgressComplete,
        backTo: '/' // Nie jest już używany, ale zachowany dla kompatybilności
    };
};